module.exports = __webpack_public_path__ + "635441f8865a5d2df6d62cb147659fcd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-25.png
// module id = 2260
// module chunks = 0